import React from 'react';

import i18next from 'i18next';

import s from '../AnalysisModal.module.scss';

const CustomLegend = (props) => {
  const { payload } = props;
  return (
    <ul className={s.legendWrapper}>
      {payload.map((entry, index) => (
        <li key={`item-${index}`} className={s.legend} style={{ color: entry.color }}>
          <div
            style={{
              background: entry.color,
            }}
            className={s.colorDot}></div>{' '}
          {i18next.t(entry.value)}
        </li>
      ))}
    </ul>
  );
};

export default CustomLegend;
